import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMessageTickSingle = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3 6.75L4.75 8.5L9 3.75",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgMessageTickSingle;
